import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** If Stripe lands on the wrong path with success params, send user to the return handler. */
const StripeReturnRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/payment/stripe-return") return;
    const params = new URLSearchParams(location.search);
    const pi = params.get("payment_intent");
    const clientSecret = params.get("payment_intent_client_secret");
    const status = params.get("redirect_status");
    if (pi && (clientSecret || status === "succeeded" || status === "processing")) {
      navigate(`/payment/stripe-return${location.search}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default StripeReturnRedirect;
